module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-md-offset-3"
  }, [_c('main-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('Sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('main-content')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fdc8e08a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lesson2/Index.vue
// module id = 33
// module chunks = 0